import axios from 'axios'
import { AgencyInvoice } from '@/domain/AgencyInvoice'
import { Invoice } from '@/domain/Invoice'

/**
 * 検索条件
 */
export class SerchConditon {
    /** 代理店請求番号 */
    agencyInvoiceNo = ""
    /** 期間開始日 */
    startOn = ""
    /** 期間終了日 */
    endOn = ""
    /** 顧客都道府県コード */
    customerPrefectureCode = ""
    /** 顧客コード */
    customerCode = ""
    /** 顧客枝番 */
    customerBranchNumber = ""
    /** 顧客名 */
    customerName = ""
    /* 有効 */
    isActive = true

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SerchConditon>) {
        Object.assign(this, init)
    }
}

/**
 * 代理店請求サービス
 */
export default class AgencyInvoicesService {
    /** インスタンス */
    private static _instance: AgencyInvoicesService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new AgencyInvoicesService();
        }
        return this._instance;
    }

    /**
     * 新規作成
     */
    public async createNew(): Promise<AgencyInvoice> {
        return await axios.get("/api/agency/invoice/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
    
    /**
     * 編集
     */
    public async edit(no: string): Promise<AgencyInvoice> {
        return await axios.get(`/api/agency/invoice/edit/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 新規保存
     */
    public async create(dto: AgencyInvoice): Promise<AgencyInvoice> {
        return await axios.post("/api/agency/invoice/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: AgencyInvoice): Promise<AgencyInvoice> {
        return await axios.put(`/api/agency/invoice/edit/${dto.agencyInvoiceNo}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 削除
     */
    public async delete(no: string): Promise<AgencyInvoice> {
        return await axios.delete(`/api/agency/invoice/delete/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 印刷
     */
    public async print(no: string): Promise<AgencyInvoice> {
        return await axios.put(`/api/agency/invoice/print/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 代理店請求一覧を検索
     */
    public async findAll(serchConditon: SerchConditon): Promise<AgencyInvoice[]> {
        return await axios.get("/api/agency/invoices", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as AgencyInvoice[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 代理店請求対象一覧を検索
     */
    public async findTarget(serchConditon: SerchConditon): Promise<Invoice[]> {
        return await axios.get("/api/agency/invoices/target", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Invoice[]).map(x => new Invoice({ ...x }))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): AgencyInvoice {
        const agencyInvoice = data as AgencyInvoice
        return new AgencyInvoice({ ...agencyInvoice })
    }
}
